import { Box, CircularProgress } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const LoadingValuesWarning = ({
  messageTextId = 'LOADING_INFORMATION_NEEDED',
  loadingElement,
  boxProps,
}: {
  messageTextId?: string;
  loadingElement?: JSX.Element;
  boxProps?: React.ComponentProps<typeof Box>;
}) => {
  const { palette, customBorderRadius } = useCustomTheme();

  const componentLoadingElement = loadingElement ?? <CircularProgress size={16} color={'secondary'} />;

  const loadingValuesWarningStyle = {
    alignItems: 'center',
    paddingLeft: '24px',
    justifyContent: 'flex-start',
    width: '100%',
    background: palette.grey[50],
    textAlign: 'center',
    boxSizing: 'border-box',
    borderRadius: customBorderRadius.paper,
    display: 'flex',
    flexDirection: 'row',
    gridGap: '8px',
  } as React.CSSProperties;
  return (
    <Box height={'44px'} style={loadingValuesWarningStyle} {...boxProps}>
      {componentLoadingElement}
      <Font variant={'body2'} style={{ color: palette.grey[500], fontWeight: 400 }}>
        <Text tId={messageTextId} />
        ...
      </Font>
    </Box>
  );
};
